export default __webpack_public_path__ + "static/media/img (3).5c7767cf.jpg";